// Alert controller
// Handles dismissible alerts with slide-out animation

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  dismiss(event) {
    event.preventDefault()

    // Notify ancestors that this alert was dismissed (bubbles) BEFORE it is
    // removed, so a consumer can react — e.g. persist the dismissal so the alert
    // doesn't reappear. No-op for alerts nobody listens to.
    this.dispatch("dismissed", { bubbles: true })

    // Add fade-out animation
    this.element.style.transition =
      "opacity 200ms ease-out, transform 200ms ease-out"
    this.element.style.opacity = "0"
    this.element.style.transform = "translateY(-8px)"

    // Remove element after animation
    setTimeout(() => {
      this.element.remove()
    }, 200)
  }
}
